import { registerRoutingKey } from "Common/routingUtils";
import locale from "./routesMap.locale";
export default {
    DOCUMENTS: registerRoutingKey("DOCUMENTS")
};
const AREA_TITLE = locale.DOCUMENTS;
export { AREA_TITLE };
